import { render, staticRenderFns } from "./GoodDay.vue?vue&type=template&id=1d044650&scoped=true"
import script from "./GoodDay.vue?vue&type=script&lang=js"
export * from "./GoodDay.vue?vue&type=script&lang=js"
import style0 from "./GoodDay.vue?vue&type=style&index=0&id=1d044650&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d044650",
  null
  
)

export default component.exports